/** @jsxImportSource theme-ui */
import { useState } from "react";
import { motion } from "framer-motion";
import { Button, useThemeUI } from "theme-ui";

import { ProductImage } from "components";
import { RotateLeftIcon, RotateRightIcon } from "components/icons";
import * as styles from "./Product.styles";

export default function ProductImageContainer({
  selectedImageViewAngle,
  imageViewAnglesObj,
  setSelectedImageAngle,
  showChangeImageAngleArrowButtons = false,
}) {
  const {
    theme: { isMobile },
  } = useThemeUI();

  const [isAnimationComplete, setIsAnimationComplete] = useState(false);

  const imageAngles = Object.keys(imageViewAnglesObj);

  const imageIndex = imageAngles.indexOf(selectedImageViewAngle);

  const makeRotateClickFunction =
    (n = 1) =>
    () => {
      const nextImageAngle =
        imageAngles[(imageIndex + n + imageAngles.length) % imageAngles.length];
      setSelectedImageAngle(nextImageAngle);
    };

  const rotateRight = makeRotateClickFunction(1);
  const rotateLeft = makeRotateClickFunction(-1);

  return (
    <motion.div
      sx={styles.productImageContainer}
      initial={{
        y: "-100%",
        opacity: 0,
      }}
      animate={{
        y: "0%",
        opacity: 1,
        transition: {
          duration: 0.3,
        },
      }}
      onAnimationComplete={() => setIsAnimationComplete(true)}
    >
      <ProductImage withPinchZoom={isAnimationComplete} />

      {showChangeImageAngleArrowButtons && (
        <>
          <Button
            type="button"
            sx={styles.rotateRightIcon}
            variant="unstyled"
            onClick={rotateLeft}
          >
            {!isMobile && <RotateRightIcon />}
          </Button>

          <Button
            type="button"
            sx={styles.rotateLeftIcon}
            variant="unstyled"
            onClick={rotateRight}
          >
            {!isMobile && <RotateLeftIcon />}
          </Button>
        </>
      )}
    </motion.div>
  );
}
